export const FIND_EVENT_BY_ID_COMPLETED = "project/events/findEventByIdCompleted";
export const FIND_EVENTS_BY_USER_ID_COMPLETED = "project/events/findEventsByUserIdCompleted";
export const ADD_EVENT_COMPLETED = "project/events/addEventCompleted";
export const UPDATE_EVENT_COMPLETED = "project/events/updateEventCompleted";
export const REMOVE_EVENT_COMPLETED = "project/events/removeEventCompleted";